import { Button, Input, Modal } from "antd";
import React, { useEffect } from "react";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { checkValidEngNumbers } from "../../../core/utils";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";

const EditEmployee = ({
  isModalOpen,
  setIsModalOpen,
  data,
  addEmployeeState,
  handleChange,
  editEmployee,
}) => {
  useEffect(() => {
    if (isModalOpen) {
      handleChange({
        first_name: data.user.first_name,
        last_name: data.user.last_name,
        national_id: data.user.national_id,
        post: data.post,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, data]);

  return (
    <Modal
      open={isModalOpen}
      key={data.id}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      closable={true}
      title="Edit Employee"
      bodyStyle={{
        paddingBottom: 8,
      }}
      closeIcon={
        <CloseModalButton isCloseIcon close={() => setIsModalOpen(false)} />
      }
    >
      <div className="flex-row flex-wrap pb-20 flex-content-space-between">
        <FormWrapper>
          <Input
            className="input-black border-black-8"
            onChange={(e) => handleChange({ first_name: e.target.value })}
            value={addEmployeeState.first_name}
            placeholder="First Name"
          />
          <Input
            className="input-black border-black-8"
            placeholder="Last Name"
            onChange={(e) => handleChange({ last_name: e.target.value })}
            value={addEmployeeState.last_name}
          />
          <Input
            className="input-black border-black-8"
            placeholder="National ID"
            onChange={(e) => handleChange({ national_id: e.target.value })}
            value={addEmployeeState.national_id}
            onKeyDown={checkValidEngNumbers}
          />
          <Input
            className="input-black border-black-8"
            placeholder="Position"
            onChange={(e) => handleChange({ post: e.target.value })}
            value={addEmployeeState.post}
          />

          <Button
            className="button-secondary w-100 "
            onClick={() => editEmployee(data.user.id, setIsModalOpen)}
          >
            Edit
          </Button>
        </FormWrapper>
      </div>
    </Modal>
  );
};

export default EditEmployee;
